import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdminAuth } from '../hooks/useAdminAuth';
import { FaLock, FaEnvelope, FaArrowRight } from 'react-icons/fa';
import adminApi from '../api/adminApi';
import '../admin.css';

const LoginPage = () => {
  const { login } = useAdminAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = e => {
    setForm(p => ({ ...p, [e.target.name]: e.target.value }));
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const email = form.email.trim();
    const password = form.password.trim();
    if (!email || !password) { setError('Please enter email and password.'); return; }
    setLoading(true);
    try {
      const res = await adminApi.post('/auth/login', { email, password });
      login(res.data.token, {
        username: res.data.username,
        email: res.data.email,
        role: res.data.role,
      });
      navigate('/admin/dashboard', { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || 'Invalid email or password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleQuickFill = () => {
    setForm({ email: 'admin@medicare.com', password: 'Admin@123' });
    setError('');
  };

  return (
    <div className="admin-login-page" id="admin-login-page">
      <div className="admin-login-card" id="admin-login-card">
        <div className="admin-login-logo" style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img
            src="/uk-dental-logo.png"
            alt="UK Dental Studio"
            style={{ maxHeight: '60px', maxWidth: '260px', objectFit: 'contain', marginBottom: '0.75rem' }}
          />
          <h1 style={{ fontSize: '1.25rem', color: 'var(--admin-navy)' }}>Admin Panel</h1>
          <p style={{ fontSize: '0.8rem', color: 'var(--admin-muted)' }}>UK Dental Studio Management</p>
        </div>

        <div style={{ background: '#f8fafc', border: '1px dashed #cbd5e1', borderRadius: '8px', padding: '0.75rem 1rem', marginBottom: '1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <div style={{ fontSize: '0.78rem', color: '#475569' }}>
            <div><strong>Email:</strong> admin@medicare.com</div>
            <div><strong>Password:</strong> Admin@123</div>
          </div>
          <button
            type="button"
            onClick={handleQuickFill}
            style={{ fontSize: '0.75rem', background: '#00b8d9', color: 'white', border: 'none', borderRadius: '6px', padding: '0.35rem 0.65rem', cursor: 'pointer', fontWeight: '600' }}
          >
            Auto Fill
          </button>
        </div>

        {error && (
          <div className="admin-login-error" id="admin-login-error">{error}</div>
        )}

        <form className="admin-login-form" onSubmit={handleSubmit} id="admin-login-form">
          <div className="admin-form-group">
            <label className="admin-form-label" htmlFor="login-email">
              <FaEnvelope style={{ marginRight: '0.4rem', opacity: 0.6 }} />Email Address
            </label>
            <input
              id="login-email"
              name="email"
              type="email"
              className="admin-form-input"
              placeholder="admin@medicare.com"
              value={form.email}
              onChange={handleChange}
              autoComplete="email"
              autoFocus
            />
          </div>
          <div className="admin-form-group">
            <label className="admin-form-label" htmlFor="login-password">
              <FaLock style={{ marginRight: '0.4rem', opacity: 0.6 }} />Password
            </label>
            <input
              id="login-password"
              name="password"
              type="password"
              className="admin-form-input"
              placeholder="••••••••"
              value={form.password}
              onChange={handleChange}
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            id="admin-login-submit"
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? '⏳ Signing in…' : <><FaArrowRight /> Sign In to Admin Panel</>}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: '1.5rem', fontSize: '0.75rem', color: '#94a3b8' }}>
          🔒 Secure admin access only. Unauthorized access is prohibited.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
